import { useApiDataService } from './use-api-data-service';
import { ActivityService } from 'services/activity-service';

export const useActivityService = () => useApiDataService<ActivityService>(ActivityService);
export default useActivityService;
